import { useContext } from 'react';
import { CalendarStoreContext } from '../CalendarStoreProvider';
import { StoreApi, UseBoundStore } from 'zustand';
import { CalendarStore } from '../calendarStore';

type Selector<T> = (state: CalendarStore) => T;

export const useCalendarStoreSelector = <T,>(selector: Selector<T>, comparer?: (a: T, b: T) => boolean) => {
	const useStore: UseBoundStore<StoreApi<CalendarStore>> = useContext(CalendarStoreContext)!;
	return useStore(selector, comparer!);
};
